import legals_en from "./legals_en";
import legals_es from "./legals_es";
import legals_fr from "./legals_fr";
import legals_it from "./legals_it";

export default {
  fr: legals_fr,
  en: legals_en,
  es: legals_es,
  it: legals_it,
};
